import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {QueryParamsModel} from "../../_base/crud";
import {Action, createReducer, on} from "@ngrx/store";
import * as SmsHistoryDetailsActions from "../ek-actions/sms-history-details.actions";
import {SmsHistoryModel} from "../ek-models/sms-history-model";

export interface SmsHistoryDetailsState extends EntityState<SmsHistoryModel> {
    listLoading: boolean;
    actionsLoading: boolean;
    totalCount: number;
    lastCreatedSmsId: number;
    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
    error: any;
    lastAction: string;
    errorMessage: string;
}

export const adapter: EntityAdapter<SmsHistoryModel> =
    createEntityAdapter<SmsHistoryModel>();

export const initialSmsHistoryDetailsState: SmsHistoryDetailsState = adapter.getInitialState({
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    lastCreatedSmsId: undefined,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true,
    error: Response,
    lastAction: '',
    errorMessage: '',
});
const posReducer = createReducer(
    initialSmsHistoryDetailsState,
    on(SmsHistoryDetailsActions.SmsHistoryDetailsPageRequested, (state, action) => ({
        ...state,
        actionsLoading: true,
        listLoading: true,
        showInitWaitingMessage: true,
        error: null,
        lastAction: '',
    })),
    on(SmsHistoryDetailsActions.SmsHistoryDetailsPageLoadedSuccessfully, (state, action) =>
        adapter.addAll(action.SmsHistory, {
            ...state,
            actionsLoading: false,
            listLoading: false,
            showInitWaitingMessage: false,
            totalCount: action.totalCount,
        })
    ),
    on(SmsHistoryDetailsActions.SmsHistoryDetailsPageLoadFailed, (state, action) => ({
        ...state,
        actionsLoading: false,
        listLoading: false,
        showInitWaitingMessage: false,
        error: action.error,
    })),
);

export function smsHistoryDetailsReducer(state: SmsHistoryDetailsState | undefined, action: Action) {
    return posReducer(state, action);
}

